function ThumbUpIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 50"
      fill="#AEAAB5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.207 21.521H2.386a1.29 1.29 0 00-1.304 1.304v20.856c0 .73.573 1.303 1.304 1.303h7.82a1.29 1.29 0 001.303-1.303V22.825a1.29 1.29 0 00-1.302-1.303zM47.918 23.992c0-2.124-1.459-4.274-4.244-4.274H31.046c1.804-3.227 2.334-7.766 1.08-11.087-.92-2.443-2.681-3.868-4.96-4.013l-.036-.003a2.731 2.731 0 00-2.89 2.5c-.324 3.294-1.767 9.12-3.836 11.188-1.741 1.742-3.232 2.472-5.703 3.68-.358.175-.749.366-1.162.572.008.09.012.178.012.27v20.643l.882.303c4.079 1.406 7.603 2.62 12.99 2.62h10.21c2.786 0 4.244-2.151 4.244-4.274 0-.63-.128-1.263-.381-1.841a4.032 4.032 0 002.342-1.297c.683-.776 1.06-1.807 1.06-2.904 0-.628-.128-1.26-.38-1.837 2.236-.387 3.4-2.306 3.4-4.204 0-1.101-.392-2.21-1.157-3.02.764-.813 1.157-1.921 1.157-3.022z" />
    </svg>
  )
}

export default ThumbUpIcon
